import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';

const useCheckMyDispositions = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const checkMyDispositions = useCallback(async (executionId:string) => {
    setLoading(true);

    try {
      const response = await api.get(`/campaign_execution/${executionId}/my_dispositions`);

      if (response?.data?.data?.length === 0) {
        toast.info('Você não possui atendimentos aguardando resposta.');
        return;
      }

      navigate(`/painel/atendimentos/${executionId}/meus-atendimentos`);
    } catch (error) {
      toast.error('Erro ao verificar se possui atendimentos aguardando resposta.');
      datadogRum.addError(new Error('Fail to check my dispositions'), {
        error,
        executionId,
      });
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  return {
    checkMyDispositions,
    loading,
  };
};

export default useCheckMyDispositions;
